export const accountColumns = {
  columns: [
    {
      name: "userName",
      label: "UserName",
    },
    {
      name: "email",
      label: "Email",
    },
    {
      name: "phone",
      label: "Phone",
    },
    {
      name: "createDate",
      label: "Create Date",
    },
  ],
};

export const permissionColumns = {
  columns: [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "action",
      label: "Action",
    },
    {
      name: "method",
      label: "Method",
    },
    {
      name: "controller",
      label: "Controller",
    },
    {
      name: "aplicacionName",
      label: "Aplication Name",
    },
  ],
};

export const rolesColumns = {
  columns: [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "description",
      label: "Description",
    },
  ],
};

export const userFieldColumns = {
  columns: [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "description",
      label: "Description",
    },
  ],
};
